import { addDaysToDate, setDateToMidnight } from "../../../utils/dates";
export * from "./filters";
export * from "./query";
export * from "./sorting";
export const deriveNewCampaignStartDate = () => setDateToMidnight(addDaysToDate(new Date(), 1));
//# sourceMappingURL=index.js.map